import { ListagemPadrao } from "../../padronizado/listagem-padrao";
import { EmpresaInterface } from "../../../types/EmpresaInteface";
import { ColunaTabela } from "../../../components/Formularios/Table/CustomTable";
import { CampoPesquisa } from "../../../components/Modais/ModalFiltro";

// Definição das colunas da tabela
const colunas: ColunaTabela<EmpresaInterface>[] = [
  { key: "id_empresa", label: "ID Empresa" },
  { key: "cnpj", label: "CNPJ" },
  { key: "ie", label: "Inscrição Estadual" },
  { key: "razao_social", label: "Razão Social" },
  { key: "fantasia", label: "Nome Fantasia" },
  { key: "cidade", label: "Cidade" },
  { key: "uf", label: "Estado" },
];

// Campos exibidos no modal de pesquisa
const camposPesquisa: CampoPesquisa<EmpresaInterface>[] = [
  { campo: "cnpj", label: "CNPJ", md: 4 },
  { campo: "razao_social", label: "Razão Social", md: 8 },
  { campo: "fantasia", label: "Nome Fantasia", md: 8 },
  { campo: "cidade", label: "Cidade", md: 4 },
];

export const Empresa: React.FC = () => {
  // Função para personalizar a mensagem de confirmação de exclusão
  const mensagemConfirmacaoExclusao = (empresa: EmpresaInterface) => {
    return `Tem certeza que deseja excluir a empresa \n ${empresa.razao_social}?`;
  };

  return (
    <ListagemPadrao<EmpresaInterface>
      titulo="Empresas"
      tela="empresa"
      endpoint="/empresas"
      colunas={colunas}
      campoId="id_empresa"
      rotaBase="/cadastro/empresa"
      camposPesquisa={camposPesquisa}
      usaPaginacaoServidor={false}
      mensagemConfirmacaoExclusao={mensagemConfirmacaoExclusao}
    />
  );
};
